export const infoTypes = {
  AUTHOR: 'author',
  PUBLICATION_DATE: 'publicationDate',
  AUTHOR_AND_PUBLICATION_DATE: 'authorAndPublicationDate',
  READING_TIME: 'readingTime',
  AUTHOR_AND_READING_TIME: 'authorAndReadingTime',
  UPDATED: 'updated',
  AUTHOR_AND_UPDATED: 'authorAndUpdated',
};

export const sortTypes = {
  LATEST: 'latest',
  OLDEST: 'oldest',
  CUSTOM: 'custom',
};
